module.exports = __webpack_public_path__ + "img/phone.283c7c04.svg";